module.exports = __webpack_public_path__ + "assets/widgets-29ead4dc5ea9c49907052ac2d0db4b4a.svg";